import Constants from "../../utils/CommonConstants";
import {InviteController} from "./controllers/InviteController";

const routes = [
    {
        name: Constants.RoutingStates.INVITE,
        url: "/invite/{participantToken}",
        views: {
            contents: {
                controller: InviteController
            }
        }
    }
    ,{
        name: Constants.RoutingStates.ORDER_SUMMARY_PAGE,
        url: "/orderSummaryPage",
        views: {
            contents: {
                template: require('./views/orderSummaryPage.jade'),
                controller: 'Cartonomy.Order.OrderSummaryPageController'
            }
        }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/modules/order/routeConfig.js